import React, { useEffect, useState, useRef } from 'react';
import { getRouterUrl, Constants, refreshCookie, refreshSession, getSessionSupportUrl, getEnv, getCorrelationId } from '../utils/Utils';
import { configMap } from '../types';
import { useCIAMAuth } from '../hooks/useCIAMAuth';
//@ts-ignore
import MicroAppLoader from '@usb-ui-tools/micro-app-loader';

export const LogoutModuleLoader = (props: any) => {
    const ref = useRef(null)
    const ciamAuth = useCIAMAuth();
    const config = configMap[getEnv(ciamAuth?.config)];
    const logoutConfigSettings = {
        transmitConfigs: {
            URL: `${config.TRANSMIT_CONFIG_URL}`,
            APP_ID: 'ciam_mps_web',
            policyIds: {
                POLICY: 'log_out'
            },
            policyParams: {
                appId: Constants.AUTH.APPLICATION_ID,
                tenantId: Constants.TENANT.ID,
                channelId: Constants.TENANT.CHANNEL,
                appVersion: Constants.AUTH.LOGIN_APP_VERSION,
                applicationId: Constants.AUTH.APPLICATION_ID,
                useCase: 'log_out',
                XProfileDataRequested: Constants.PROFILE.X_DATA_REQUESTED,
                clientId: '',
                correlationId: getCorrelationId(),
                token: ciamAuth.ciamSession?.jwtToken,
                accesstoken: ciamAuth.ciamSession?.ciamUser?.custom_data?.at,
                routingKey: `${config.ROUTING_KEY}`,
                targetApp: `${ciamAuth.config.appId}`,
            }
        },
        header: {
            'App-ID': Constants.AUTH.APPLICATION_ID,
            'Tenant-ID': Constants.TENANT.ID,
            'Channel-ID': Constants.TENANT.CHANNEL,
            'App-Version': Constants.AUTH.LOGIN_APP_VERSION,
            AK: `${config.HEADER_AK}`,
        },
    }

    const logoutCallBack = async () => {
        await props.logOutFunc(ciamAuth.ciamSession, props.skipLogoutRedirect, props.inactivity);
    }

    const challengeModuleProps = {
        userName: ciamAuth.ciamSession?.ciamUser?.sub,
        configSettings: logoutConfigSettings,
        onTransmitAuthorizationFailure: logoutCallBack,
        onTransmitAuthorizationSuccess: logoutCallBack,
        onTransmitInitFailure: logoutCallBack,
        isIovationEnabled: false,
        disableSpinner: true
    };
    return <MicroAppLoader
        elementRef={useRef(null)}
        id={`usb-logout-auth-challenge`}
        namespace='USBAuthChallenge'
        manifestPath={config.MANIFEST_LOGOUT_PATH}
        isDomainPrefixedToManifestPath={false}
        appProps={challengeModuleProps}
    />
}